module.exports = __webpack_public_path__ + "img/FGr_Schwere_Bergung.0731226c.svg";